<!--
 * @Author: yeqing
 * @Date: 2021-11-24 10:19:44
 * @LastEditTime: 2022-05-12 11:23:57
 * @LastEditors: yeqing
 * @Description: 专精能力组件
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\smEvaluation\components\specializationModel.vue
-->
<template>
	<div class="specializationModel">
		<a-form>
			<a-form-item label="1、企业主导产品是否通过发达国家和地区的认证(国际标准协会行业认证)。如UL、CSA、ETL、GS认证证书等，不包括国内认证">
				<a-radio-group name="radioGroup" v-model="specialization.q421">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="2、企业是否拥有自主品牌">
				<a-radio-group name="radioGroup" v-model="specialization.q422">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="3、企业是否为龙头企业、大企业或重点工程项目提供配套产品(服务)，并签订合同协议：">
				<a-radio-group name="radioGroup" v-model="specialization.q423">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<a-form-item label="4、企业是否获得技术、质量、工程、环保、安全等资质或资格认定">
				<a-radio-group name="radioGroup" v-model="specialization.q424">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<a-form-item
				label="5、企业是否拥有至少1项核心业务采用信息系统支撑，或业务系统云端迁移。如研发设计CAX、生产制造CAM、经营管理ERP/OA 、运维服务CRM、供应链管理SRM等"
			>
				<a-radio-group name="radioGroup" v-model="specialization.q425">
					<a-radio value="是">是</a-radio>
					<a-radio value="否">否</a-radio>
				</a-radio-group>
			</a-form-item>
			<div style="text-align: center; margin-top: 40px;">
				<a-button class="primary-btn pre-btn" @click="handlePre">上一步</a-button>
				<a-button class="primary-btn" @click="handleNext">下一步</a-button>
			</div>
		</a-form>
	</div>
</template>

<script>
export default {
	name: "specializationModel",
	data() {
		return {
			specialization: {
				q421: "",
				q422: "",
				q423: "",
				q424: "",
				q425: "",
			},
		};
	},
	methods: {
		// 下一步
		handleNext(e) {
			e.preventDefault();
			this.$emit("changeTabKey", {
				name: "specialization",
				key: 3,
				data: this.specialization,
			});
		},
		// 上一步
		handlePre(e) {
			e.preventDefault();
			this.$emit("changeTabKey", {
				name: "specialization",
				key: 1,
				data: this.specialization,
			});
		},
	},
};
</script>
<style lang="less" scoped>
.specializationModel {
	margin-top: 30px;
	.row-box {
		.lable {
			margin: 0;
			padding: 0 0 8px;
			line-height: 1.5;
			white-space: initial;
			text-align: left;
			font-family: PingFangSC-Regular, PingFang SC;
			color: #333333;
			margin-right: 6px;
			font-size: 14px;
			> span {
				color: #999999;
			}
		}
	}
}
</style>